import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { createGenre } from '../../../../api';
import Input from '../../../../common/Input';
import useRouteStore from '../../../../hooks/useRouteStore';
import { swalConfig, toastConfig } from '../../../../config';

const CreateGenre = () => {
  const mySwal = withReactContent(Swal);
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();
  const setRoute = useRouteStore((state) => state.setRoute);

  useEffect(() => {
    setRoute([
      { name: 'Inicio', url: '/administracion' },
      { name: 'Géneros', url: '/administracion/generos' },
      { name: 'Nuevo género', url: '/administracion/generos/nuevo' },
    ]);
  }, []);

  const handleCreate = async () => {
    if (!name.trim()) return;
    const res = await mySwal.fire({ ...swalConfig.confirm, text: `¿Crear el género "${name.trim()}"?` });
    if (res.isConfirmed) {
      setCreating(true);
      try {
        await createGenre({ name: name.trim() });
        toast.success('Género creado', toastConfig);
        navigate('/administracion/generos');
      } catch (err) {
        toast.error(err.response?.data?.message || 'Error al crear el género', toastConfig);
        setCreating(false);
      }
    }
  };

  return (
    <div className='font-montserrat w-full'>
      <div className='flex items-center pb-1 mb-5 border-b-2'>
        <h1 className='font-semibold text-xl'>Nuevo género</h1>
      </div>
      <div className='max-w-md'>
        <Input id='name' value={name} onChange={(e) => setName(e.target.value)} label='Nombre' labelClassName='w-24' />
        <div className='mt-4 flex justify-end'>
          <button
            onClick={handleCreate}
            disabled={!name.trim() || creating}
            className='flex items-center gap-1.5 bg-red-1 hover:bg-red-2 text-white text-sm font-semibold px-3 py-1.5 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
          >
            {creating ? (
              <svg className='animate-spin h-3.5 w-3.5' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
                <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
                <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 22 6.477 22 12h-4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
              </svg>
            ) : (
              <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2.5}>
                <path strokeLinecap='round' strokeLinejoin='round' d='M12 4v16m8-8H4' />
              </svg>
            )}
            Crear género
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateGenre;
